import styled from 'styled-components';

export const StyledDashboard = styled.div`
  background-color: white;
  .dx-overlay-wrapper.dx-toast-wrapper {
    z-index: 0 !important;
  }
`;
